<p>
  loginwithlink works!
</p>
